export default __webpack_public_path__ + "static/media/Blog12.dfa62e51.png";